import { useRecoilValue } from "recoil";
import { userState } from "pages/_app";

export const useUser = () => {
  const user = useRecoilValue(userState);
  const isAuthChecking = user === undefined;

  return {
    user,
    isAuthChecking,
  };
};
